import { useState, useEffect } from 'react';
import { Grid, makeStyles, Typography, Link } from "@material-ui/core";
import UtilService from "../../../../../../../../helper/service";
import roles from '../../../../../../../../helper/roles';
import { useHistory } from 'react-router';


interface IProps {
    participantsStatus: any;
    participants: any;
    confidenceScore: string;
  }


  const ConfidenceScore = (props: IProps) => {
    const classes = useStyles();
    const history = useHistory();
    const { participantsStatus, participants, confidenceScore } = props;

    const [commentary, setCommentary] = useState("Analyzing...");
   // const [conScore, setConScore] = useState("F");

    const haveParticipantArray = participants?.participants && participants?.participants.length >= 1;

    useEffect(() => {
        if (!!participantsStatus && haveParticipantArray) {
          
            

            if (confidenceScore === "A+" ) {
                setCommentary("Brilliant! With strong data and quality sample size, you can feel confident that this result will predict behavior.");
                //setConScore("A+");
            } else if (confidenceScore === "A") {
                setCommentary(`Perfect! You designed a great content test with exactly the right audience size.  This is a robust and repeatable result.`);
                //setConScore("A");
            } else if (confidenceScore === "B+") {
                setCommentary(`Pretty good.  You can feel reasonably confident that this result will repeat.  However, you might want to add a few more participants to gain that extra bit of confidence.`);
                //setConScore("B+");
            } else if (confidenceScore === "B") {
                setCommentary(`Good work. You can learn a lot about the content even at this confidence level. If you are in build/design mode, this is the level you want.  If you are trying to make a big or important decision, we would recommend that you test a few more brains.`);
                //setConScore("B");
            }  else if (confidenceScore === "C+") {
                //setConScore("C");
                setCommentary(`Nice. This was a good test and you can use these results to guide development. Remember to add more participants if you really want to know how this will perform in market.`);
            }  else if (confidenceScore === "C") {
                //setConScore("C");
                setCommentary(`Ok. This is a good 'swag' at neuroscience and will likely give you some interesting insight about the content.  However, if you want to learn more about who will love this, you need to test more brains.`);
            }  else if (confidenceScore === "D") {
                //setConScore("C");
                setCommentary(`It's fun, right? This was a good test of the system, and you can see how a handful of brains will likely respond to this experience.  Now, add more brains to the mix and see what you can learn about your audience.`);
            }  

        }
      }, [props]);
    
      const goToSetup = () => {
        
        const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
        const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
        let url = `/creator/experience-manager/participants/${currentSessionCode}`;
        if (!!userData) {
          if (UtilService.checkTrialAccess(userData, roles['trial']['experiences'])) {
            url = `/subscriber/creator/experience-manager/participants/${currentSessionCode}`;
          }
        }
        history.push(url, { session_id: localStorage.getItem("session_id") ? localStorage.getItem("session_id") : "" });
      };




    return (

        <Grid item xs={4} style={{textAlign: 'center'}} >
            <Typography variant="h1" color={'primary'} className={classes.itemtitle}>{!!confidenceScore ? confidenceScore : "-"}</Typography>
            <Typography variant="body1" className={classes.sectionTitle}>Confidence Score</Typography>
            <Typography variant="body1" className={classes.bodyText}>{commentary}</Typography>
            <Link className={classes.actionLink} onClick={goToSetup}>
                <Typography variant="body1" className={classes.foo}>Copy & Run Again</Typography>
            </Link>
          </Grid>

    )


  }

  export default ConfidenceScore;

  const useStyles = makeStyles(() => ({
    root: {
      paddingTop: 0,
      '@media (max-width: 600px)': {
        paddingTop: 0,
      },
    },
    itemtitle: {
        fontSize: 90,
        fontFamily: 'Spartan-bold',
        marginBottom: -30,
    },
    actionLink: {
      cursor:'pointer',
      //color: '#6667ab',
    },
    subtitle: {
        fontSize: 24,
        color: '#cccccc'
    },
    bodyText: {
        color: '#697683',
        fontFamily: 'roboto-light',
    },
    sectionTitle: {
      fontSize: 16,
      fontFamily: 'roboto-bold',
      color: '#697683'
    },
    typeTitle: {
      fontSize: 24,
      fontFamily: 'Spartan-bold',
      color: '#697683',
      textAlign: 'center',
    },
    titleSection: {
      maxWidth: 500,
      display: 'flex',
      alignItems: 'center'
    },
    numberTitle: {
      marginTop: 5,
      fontSize: 29,
      minWidth: 60,
      textAlign: 'center',
      fontFamily: 'Spartan-extrabold',
      padding: '0 15px',
      '@media screen and (max-width: 600px)': {
        fontSize: 30
      }
    },
    title: {
      minWidth: 146,
      marginTop: 5,
      fontSize: 20,
      fontFamily: 'Spartan-bold',
      letterSpacing: '2px',
      textTransform: 'uppercase',
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        fontSize: 20
      },
      '@media screen and (max-width: 330px)': {
        fontSize: 18
      }
    },
    titleIcon: {
      width: 42,
      height: 42,
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        width: 35,
        height: 35
      },
      '@media screen and (max-width: 330px)': {
        width: 30,
        height: 30
      }
    },
    cardSection: {
      borderRadius: 20,
      background: '#fff',
      boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)"
    },
    pdfCardSection: {
      borderRadius: 20,
      background: '#fff',
      border: '1px solid rgba(0, 0, 0, 0.1)',
    },
    foo:{}
  }));